import React, {useState, useEffect} from 'react';
import { PackageTrackingDetails } from '../../../types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import LabeledComponent from '../Shared/LabeledComponent';
import ProgressBarsComponent from './ProgressBarsComponent';

const DateWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    > *:last-child {
        text-align: end
    }
`;

const StatusWrapper = styled.div`
    padding-bottom: 10px;
`;

interface ProgressProps {
    packageDetails: PackageTrackingDetails;
}

const ProgressComponent = ({packageDetails}: ProgressProps) => {
    const [t] = useTranslation();
    const showProgressBar = packageDetails.VisibleProgressStates && packageDetails.VisibleProgressStates.length > 0;

    return(
        <div id={'package-progress'}>
            <DateWrapper>
                {packageDetails.BookedDate ? 
                    <LabeledComponent labelText={t('package_progress_booked')}>
                        {packageDetails.BookedDate}
                    </LabeledComponent> 
                    : // empty div to maintain spacing
                    <div />}
                {packageDetails.ExpectedDate ?
                    <LabeledComponent labelText={t('package_progress_expected')}>
                        {packageDetails.ExpectedDate}
                    </LabeledComponent>
                    : // empty div to maintain spacing
                    <div />}
            </DateWrapper>

            <StatusWrapper>
                {showProgressBar ? 
                <>
                    <ProgressBarsComponent
                        currentState={packageDetails.CurrentProgressState}
                        visibleStates={packageDetails.VisibleProgressStates}
                        isCurrentStateFailed={packageDetails.IsCurrentProgressStateFailed}
                    />
                </> :
                <>
                    <LabeledComponent labelText={t('package_tracking_details_current_status')}>
                        {packageDetails.Status}
                    </LabeledComponent>
                </>}
            </StatusWrapper>
        </div>
    );
};

export default ProgressComponent;